module.exports = __webpack_public_path__ + "img/stairs-mirrored.45de253d.png";